import { Stack, Typography } from "@mui/joy";
import { memo } from "react";
import { useRecoilValue } from "recoil";
import {
  conceptKeyMapping,
  ConceptKeyType,
  CoreBeliefKeyType,
  IntermediateBeliefKeyType,
} from "api/conceptApi";
import { conceptAtom } from "recoil/conceptAtom";
import { conceptNoteAtom } from "recoil/conceptNoteAtom";
import { theme } from "styles/theme";

function ConceptItemCell({
  taskKey,
  conceptKey,
  isNotConfirmed,
}: {
  taskKey: string;
  conceptKey: ConceptKeyType;
  isNotConfirmed?: boolean;
}) {
  const conceptState = useRecoilValue(conceptAtom);
  const conceptNoteState = useRecoilValue(conceptNoteAtom);
  const data = isNotConfirmed ? conceptNoteState : conceptState;
  return data ? (
    <Stack spacing={"8px"}>
      {Object.entries(data[conceptKey] || {})
        .filter(([key, value]) => (value as string)?.trim().length > 0)
        .map(([key, value]) => (
          <Stack key={`${key}`} spacing={"8px"}>
            <Typography
              variant={"Caption"}
              sx={{
                color: theme.vars.palette.Content.Highlight,
                fontWeight: 700,
              }}
            >
              {
                conceptKeyMapping[
                  key as CoreBeliefKeyType | IntermediateBeliefKeyType
                ]
              }
            </Typography>
            <Typography
              variant={"Body"}
              sx={{
                color: theme.vars.palette.Content.Strong,
                fontWeight: 500,
              }}
            >
              {(value as string) || ""}
            </Typography>
          </Stack>
        ))}
    </Stack>
  ) : (
    <></>
  );
}

export default memo(ConceptItemCell);
